"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialModalState = void 0;
exports.initialModalState = {
    modal1: { isOpen: false },
    modal2: { isOpen: false }
};
